const goBack = () => {
    window.history.back();
};

export { goBack };
